window.tkRatingsLoad = () => {
	window.ElementToggleContent.init('.js-ratings--content');
	window.LazyImage.update();

	window.tkTextTruncate.update();
	window.tkGallery.update();
};
